export const PRODUCT_INTENSITY_MAX = 12;
export const PRODUCT_INTENSITY_DOTS = 6;

export function getProductIntensityDots(intensity: number) {
	const scaledIntensity = intensity / (PRODUCT_INTENSITY_MAX / PRODUCT_INTENSITY_DOTS);
	return Array.from({ length: PRODUCT_INTENSITY_DOTS }).map((_, i) => {
		const dotNumber = i + 1;
		return {
			isActive: dotNumber <= scaledIntensity,
			isHalf:
				Math.round(scaledIntensity) !== scaledIntensity && Math.round(scaledIntensity) === dotNumber
		};
	});
}
